import { render } from "./AcPhoneInput.vue?vue&type=template&id=70ec68b3&ts=true"
import script from "./AcPhoneInput.vue?vue&type=script&lang=ts"
export * from "./AcPhoneInput.vue?vue&type=script&lang=ts"

import "./AcPhoneInput.vue?vue&type=style&index=0&id=70ec68b3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__